import React, {useEffect, useState} from "react";
import { Line } from 'react-chartjs-2';
import Loading from "../../../common/Loading";
import { BeaconTrendFilter } from "../../DataSet/StatisticsFilter/StatisticsFilter";
import {
  CHART_COLORS,
  CHART_COLORS_BY_COUNTRY,
  CHART_COLORS_BY_PLATFORM,
  POINT_STYLE_BY_BEACON_TYPE
} from "../../../common/ChartConsts";
import { ISS_BASE_URL } from "../../../../../constants";
import { getHeaders } from "../../../../../util/actionUtil";
import { getScalesMaxValue } from '../../../utils/IssUtils';
import { beacon_hourly_trend_data } from "./StatisticsTrendData";
import {ROWHEADER_TYPE} from "../../../consts/IssConsts";

function BeaconBaselineDocCountTrend(props) {
  const { height, title, originalFilter, currentFilter, updateTable } = props;
  const [trendData, setTrendData] = useState({data: {}, options: {}});
  const [isTrendDisplay, setIsTrendDisplay] = useState(false);
  const [displayBeaconTypes, setDisplayBeaconTypes] = useState(BeaconTrendFilter.customCheckboxFilter[0].beaconTypes);
  const chartColors = [CHART_COLORS.PURPLE, CHART_COLORS.PINK, CHART_COLORS.MINT, CHART_COLORS.BLUE, CHART_COLORS.ORANGE];
  const [displayType, setDisplayType] = useState('h')

  useEffect(() => {
    if (currentFilter) {
      getTrendData(currentFilter)
    }
  }, [currentFilter]);

  function getColor(compareType, item) {
    if (compareType === 'Country') {
      return CHART_COLORS_BY_COUNTRY[item] || CHART_COLORS_BY_COUNTRY['OTHERS'];
    } else {
      return CHART_COLORS_BY_PLATFORM[item] || CHART_COLORS_BY_PLATFORM['OTHERS'];
    }
  }

  const hexToRgba = (hex, opacity) => {
    const r = parseInt(hex.slice(1, 3), 16);
    const g = parseInt(hex.slice(3, 5), 16);
    const b = parseInt(hex.slice(5, 7), 16);
    return `rgba(${r}, ${g}, ${b}, ${opacity})`;
  };

  const convertPlatformFormat = (platform) => {
    return platform.replace('webOS', 'webOSTV').replace('webOSTV 22', 'webOSTV 7.0')
  }

  const trimLegendList = (elements, limit) => {
    if (elements && elements.length > limit) {
      return elements.slice(0, limit);
    }
    return elements
  }

  const getTrendData = (filter) => {
    let selectedBeaconTypes = [...displayBeaconTypes];
    let selectedDisplayType = displayType
    let lookupPeriods = [];
    const dateFilter = filter.date.length === 2 ? filter.date[1] : filter.date[0];
    const timeFilter = filter.time ? filter.time : '00:00';
    const selectedDatetime = dateFilter + " " + timeFilter;

    if (filter.customCheckboxFilter && filter.customCheckboxFilter.length > 0) {
      const customCheckboxFilters = filter.customCheckboxFilter.reduce((acc, cur) => {
        return {...acc, ...cur}
      })

      selectedBeaconTypes = customCheckboxFilters['beaconTypes']
      setDisplayBeaconTypes([...selectedBeaconTypes])
    }

    if (filter.customRadioFilter && filter.customRadioFilter.length > 0) {
      const customRadioFilters = filter.customRadioFilter.reduce((acc, cur) => {
        return {...acc, ...cur}
      })

      selectedDisplayType = customRadioFilters['displayType'] === 'Hourly Sequential' ? 'h' : 'w'
      setDisplayType(selectedDisplayType)
      lookupPeriods = customRadioFilters['lookupPeriods']
    }

    let param = `fromDate=${selectedDatetime}`;
    if (filter.country) param += `&countries=${filter.country}`
    if (filter.platforms) param += `&platforms=${filter.platforms}`
    if (selectedBeaconTypes.length !== 0) param += `&beaconTypes=${selectedBeaconTypes.join(',')}`
    if (lookupPeriods.length !== 0) param += `&lookupPeriods=${lookupPeriods}`
    param += `&periodType=${selectedDisplayType}`
    param += `&compareType=${filter.compareType}`

    fetch(`${ISS_BASE_URL}/api/statistics/dashboard/beacon/trend/fromdate?${param}`, {
      method: 'GET',
      headers: getHeaders(),
    })
      .then(res => res.json())
      .then(body => {

        const data = {
          labels: [...new Set(body.map(item => item.period.substring(5)))].sort(),
          datasets: [],
        }
        const options = {
          responsive: true,
          maintainAspectRatio: false,
          plugins: {
            datalabels: {
              display: false,
            },
          },
          scales: {
            y: {
              min: 0,
              max: Math.floor(getScalesMaxValue(Math.max(...body.map(item => item.docCount)))),
            },
            x: {
              ticks: {
                callback: function(value, index, values) {
                  if (data.labels[index] && (data.labels[index]).length > 5) {
                    if (index > 0 && (data.labels[index - 1]).substring(0, 5) === (data.labels[index]).substring(0, 5)) {
                      return '';
                    }
                    return (data.labels[index]).substring(0, 5);
                  } else {
                    return data.labels[index];
                  }
                }
              }
            }
          }
        }
        let graphDatasets = [];

        if (!filter.compareType) filter.compareType = 'None'
        if (filter.compareType === 'None') {
          selectedBeaconTypes.forEach((beacon, index) => {
            let filtered = body
              .filter(item => item.dataSourceType === beacon)
              .sort(function (a, b) {
                if (a.period > b.period) return 1;
                else return -1;
              });
            graphDatasets.push({
              label: beacon,
              data: filtered.map(item => item.docCount),
              fill: false,
              pointRadius: 3,
              pointBorderColor: '#FFFFFF',
              borderColor: chartColors[index],
              backgroundColor: chartColors[index],
              pointBackgroundColor: chartColors[index],
              pointBorderWidth: 2,
              order: 2,
            });
          });
        } else if (filter.compareType === 'Country') {
          selectedBeaconTypes.forEach((beacon) => {
            filter.country.forEach((country) => {
              let filtered = body.filter(item => item.dataSourceType === beacon && item.countryCode === country)
                .sort(function (a, b) {
                  if (a.period > b.period) return 1
                  else return -1
                })
              graphDatasets.push({
                label: `${beacon}_${country}`,
                data: filtered.map(item => item.docCount),
                fill: false,
                pointRadius: 3,
                pointBorderColor: '#FFFFFF',
                borderColor: hexToRgba(getColor(filter.compareType, country), 1),
                backgroundColor: hexToRgba(getColor(filter.compareType, country), 1),
                pointBackgroundColor: hexToRgba(getColor(filter.compareType, country), 1),
                pointBorderWidth: 2,
                order: 2,
                pointStyle: POINT_STYLE_BY_BEACON_TYPE[beacon]
              })
            })
          })
        } else {
          selectedBeaconTypes.forEach((beacon) => {
            filter.platforms.forEach((platform) => {
              let filtered = body.filter(item => item.dataSourceType === beacon && item.platform === convertPlatformFormat(platform))
                .sort(function (a, b) {
                  if (a.period > b.period) return 1
                  else return -1
                })
              graphDatasets.push({
                label: `${beacon}_${platform}`,
                data: filtered.map(item => item.docCount),
                fill: false,
                pointRadius: 3,
                pointBorderColor: '#FFFFFF',
                borderColor: hexToRgba(getColor(filter.compareType, platform), 1),
                backgroundColor: hexToRgba(getColor(filter.compareType, platform), 1),
                pointBackgroundColor: hexToRgba(getColor(filter.compareType, platform), 1),
                pointBorderWidth: 2,
                order: 2,
                pointStyle: POINT_STYLE_BY_BEACON_TYPE[beacon]
              })
            })
          })
        }

        data.datasets = graphDatasets;
        setTrendData({data: data, options: options});
        setIsTrendDisplay(true);

        if (filter.compareType === 'Country') {
          let tableData = body.reduce((acc, cur) => {
            const { period, dataSourceType, docCount, countryCode } = cur
            let tableRow = acc.find(item => item.period === period && item.countryCode === countryCode);
            if (tableRow) {
              tableRow[dataSourceType] = docCount
            } else {
              acc.push({period: period, countryCode: countryCode, [dataSourceType]: docCount})
            }
            return acc
          }, [])
          tableData = tableData.sort(function (a, b) {
            if (a.countryCode < b.countryCode) return -1
            if (a.countryCode > b.countryCode) return 1
            return new Date(a.period) - new Date(b.period)
          })
          beacon_hourly_trend_data.rowdata = tableData.map(item => ({
            row: [item.period, item.countryCode].concat(selectedBeaconTypes.map(beacon => item[beacon]))
          }))
          beacon_hourly_trend_data.header = ['Date', 'Country'].concat(selectedBeaconTypes)
          beacon_hourly_trend_data.cellStyle = Array(selectedBeaconTypes.length + 2)
            .fill(ROWHEADER_TYPE.NORMAL)
          beacon_hourly_trend_data.cellWidth = Array(selectedBeaconTypes.length + 2)
            .fill(Math.round(100 / (selectedBeaconTypes.length + 1)));

          updateTable(beacon_hourly_trend_data)

        } else if (filter.compareType === 'Platform') {
          let tableData = body.reduce((acc, cur) => {
            const { period, dataSourceType, docCount, platform } = cur
            let tableRow = acc.find(item => item.period === period && item.platform === platform);
            if (tableRow) {
              tableRow[dataSourceType] = docCount
            } else {
              acc.push({period: period, platform: platform, [dataSourceType]: docCount})
            }
            return acc
          }, [])
          tableData = tableData.sort(function (a, b) {
            if (a.platform < b.platform) return -1
            if (a.platform > b.platform) return 1
            return new Date(a.period) - new Date(b.period)
          })
          beacon_hourly_trend_data.rowdata = tableData.map(item => ({
            row: [item.period, item.platform].concat(selectedBeaconTypes.map(beacon => item[beacon]))
          }))
          beacon_hourly_trend_data.header = ['Date', 'Platform'].concat(selectedBeaconTypes)
          beacon_hourly_trend_data.cellStyle = Array(selectedBeaconTypes.length + 2)
            .fill(ROWHEADER_TYPE.NORMAL)
          beacon_hourly_trend_data.cellWidth = Array(selectedBeaconTypes.length + 2)
            .fill(Math.round(100 / (selectedBeaconTypes.length + 1)));

          updateTable(beacon_hourly_trend_data)

        } else {
          const reduceByDatetime = body.reduce((acc, cur) => {
            const { period, dataSourceType, docCount } = cur
            if (!acc[period]) {
              acc[period] = { period, data: {} }
            }
            acc[period].data[dataSourceType] = docCount
            return acc
          }, {});

          const tableData = Object.values(reduceByDatetime).sort(function (a, b) {
            if (a.period > b.period) return 1
            else return -1
          })

          beacon_hourly_trend_data.rowdata = tableData.map(item => ({
            row: [item.period].concat(selectedBeaconTypes.map(beacon => item.data[beacon]))
          }))
          beacon_hourly_trend_data.header = ['Date'].concat(selectedBeaconTypes)
          beacon_hourly_trend_data.cellWidth = Array(selectedBeaconTypes.length + 1)
            .fill(Math.round(100 / (selectedBeaconTypes.length + 1)));

          updateTable(beacon_hourly_trend_data)
        }
      })
  }

  return (
    <>
      {
        isTrendDisplay ? (
          <div style={{height: height}}>
            <div className="trend-head">
              <div className="title" style={{top: "-30px"}}>
                <div>{title}</div>
              </div>
              <div className="legend">
                <ul>
                  {
                    currentFilter.compareType === 'None' && (
                      displayBeaconTypes.map((beacon, index) => (
                        <li key={index}>
                          <i style={{backgroundColor: chartColors[index]}}/>
                          <span>{beacon}</span>
                        </li>
                      ))
                    )
                  }
                  {
                    currentFilter.compareType === 'Country' && (
                      trimLegendList(currentFilter.country, 13).map((country) => (
                        <li key={country}>
                          <i style={{backgroundColor: hexToRgba(getColor(currentFilter.compareType, country), 1)}}/>
                          <span>{country}</span>
                        </li>
                      ))
                    )
                  }
                  {
                    currentFilter.compareType === 'Platform' && (
                      trimLegendList(currentFilter.platforms, 7).map((platform) => (
                        <li key={platform}>
                          <i style={{backgroundColor: hexToRgba(getColor(currentFilter.compareType, platform), 1)}}/>
                          <span>{platform}</span>
                        </li>
                      ))
                    )
                  }
                </ul>
              </div>
            </div>
            <Line id={'beacon-doc-count'} data={trendData.data} options={trendData.options}/>
          </div>
        ) : (
          <div>
            <Loading isVisible={true} />
          </div>
        )
      }
    </>
  )
}

export default BeaconBaselineDocCountTrend;